__turbopack_context__.v({
  "backdrop": "EstadoModalSelector-module__iaE0qa__backdrop",
  "clearSearchBtn": "EstadoModalSelector-module__iaE0qa__clearSearchBtn",
  "fadeIn": "EstadoModalSelector-module__iaE0qa__fadeIn",
  "iconBadge": "EstadoModalSelector-module__iaE0qa__iconBadge",
  "modalCard": "EstadoModalSelector-module__iaE0qa__modalCard",
  "searchContainer": "EstadoModalSelector-module__iaE0qa__searchContainer",
  "searchIconWrapper": "EstadoModalSelector-module__iaE0qa__searchIconWrapper",
  "searchInput": "EstadoModalSelector-module__iaE0qa__searchInput",
  "stateButton": "EstadoModalSelector-module__iaE0qa__stateButton",
  "stateButtonSelected": "EstadoModalSelector-module__iaE0qa__stateButtonSelected",
  "stateGrid": "EstadoModalSelector-module__iaE0qa__stateGrid",
  "stateListScroll": "EstadoModalSelector-module__iaE0qa__stateListScroll",
  "zoomIn": "EstadoModalSelector-module__iaE0qa__zoomIn",
});
